import { render, staticRenderFns } from "./CommunityTickets.vue?vue&type=template&id=42d7c0f3&"
import script from "./CommunityTickets.vue?vue&type=script&lang=js&"
export * from "./CommunityTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports